export const txt = (site, key, fallback = "") => {
  const v = site?.[key];
  return v === undefined || v === null || v === "" ? fallback : v;
};
